import React, { Component, PropTypes } from 'react'
import { lang } from '../../strings'
import DatePicker from 'react-datepicker'
import { getDate, formatDate } from '../../utils/date'
import { trackEvent, EDIT_ADDRESSES, LOAD } from '../../utils/analytics'

export default class EditAddresses extends Component {
  constructor(props) {
    super(props)
    this.state = this.makeInitialState(props)
  }

  makeInitialState(props) {
    return {
      careOf: '',
      addressLine1: '',
      postCode: '',
      area: '',
      selectedDate: getDate(),
      addressIdsToUpdate: [],
    }
  }

  componentDidMount() {
    trackEvent(EDIT_ADDRESSES, LOAD)
  }

  render() {
    let { onClose, deliveryAddress, invoiceAddresses } = this.props
    let { selectedDate, careOf, addressLine1, postCode, area } = this.state
    return (
      <div className='c-edit-addresses mp-popup-container'>
        <div className='mp-popup-content'>
          <a href='#' className='mp-close' onClick={onClose}>
            &times;
          </a>
          <h2 className='h5 color-dark-blue'>
            {lang.customer.addresses.edit.title}
          </h2>
          <p className='no-margin'>{lang.customer.addresses.edit.intro}</p>
          <form onSubmit={this.submitForm} className='sqs-block-form'>
            <div className='form-item'>
              <label>{lang.customer.addressLine1}</label>
              <input
                type='text'
                maxLength='27'
                name='adressLine1'
                onChange={this.handleAddressLine1}
                value={addressLine1}
                required
              />
            </div>
            <div className='form-item'>
              <label>{lang.customer.careOf}</label>
              <input
                type='text'
                maxLength='23'
                name='c/o'
                onChange={this.handleCareOf}
                value={careOf}
              />
            </div>
            <div className='form-item'>
              <label>{lang.customer.postCode}</label>
              <input
                type='text'
                maxLength='6'
                name='postCode'
                onChange={this.handlePostCode}
                pattern='^\d{3} ?\d{2}$'
                value={postCode}
                required
              />
            </div>
            <div className='form-item'>
              <label>{lang.customer.area}</label>
              <input
                type='text'
                maxLength='13'
                name='area'
                onChange={this.handleArea}
                value={area}
                required
              />
            </div>
            <div className='form-item'>
              <label>{lang.customer.addresses.edit.from}</label>
              <DatePicker
                minDate={getDate()}
                locale='sv'
                selected={selectedDate}
                onChange={this.onDateChange}
              />
            </div>
            <div className='form-item'>
              <label>{lang.customer.addresses.edit.currentAddresses}</label>
              <ul className='mp-list'>
                <li>
                  <label
                    className={this.setClass(
                      deliveryAddress.hasActiveAddressChangeTask
                    )}
                  >
                    <input
                      type='checkbox'
                      name='address'
                      value={deliveryAddress.id}
                      onChange={this.handleAddressChange}
                    />{' '}
                    {lang.customer.address}
                    <br />
                    <small>
                      {deliveryAddress.careOf} {deliveryAddress.addressLine1},{' '}
                      {deliveryAddress.postCode} {deliveryAddress.area}
                    </small>
                  </label>
                </li>
                {invoiceAddresses.map(address => (
                  <li key={address.id}>
                    <label
                      className={this.setClass(
                        address.hasActiveAddressChangeTask
                      )}
                    >
                      <input
                        type='checkbox'
                        name='address'
                        value={address.id}
                        onChange={this.handleAddressChange}
                      />{' '}
                      {lang.customer.invoiceAddress} {address.customerNumber}
                      <br />
                      <small>
                        {address.careOf} {address.addressLine1},{' '}
                        {address.postCode} {address.area}
                      </small>
                    </label>
                  </li>
                ))}
              </ul>
              <div className='mp-info'>
                {lang.customer.addresses.edit.important}
              </div>
            </div>
            <input
              type='submit'
              className='sqs-editable-button'
              value={lang.customer.addresses.edit.button}
            />
          </form>
        </div>
      </div>
    )
  }

  setClass(hasActiveAddressTask) {
    return hasActiveAddressTask ? 'mp-disabled' : ''
  }

  handleAddressChange = ev => {
    let { addressIdsToUpdate } = this.state
    if (ev.target.checked) {
      addressIdsToUpdate.push(ev.target.value)
    } else {
      let index = addressIdsToUpdate.indexOf(ev.target.value)
      if (index > -1) {
        addressIdsToUpdate.splice(index, 1)
      }
    }

    this.setState({ addressIdsToUpdate: addressIdsToUpdate })
  }

  onDateChange = date => {
    this.setState({ selectedDate: date })
  }

  handleCareOf = ev => {
    this.setState({ careOf: ev.target.value })
  }

  handleAddressLine1 = ev => {
    this.setState({ addressLine1: ev.target.value })
  }

  handlePostCode = ev => {
    this.setState({ postCode: ev.target.value.replace(/\D/g, '') })
  }

  handleArea = ev => {
    this.setState({ area: ev.target.value })
  }

  submitForm = ev => {
    ev.preventDefault()

    let {
      careOf,
      addressLine1,
      postCode,
      area,
      id,
      customerNumber,
      updateDeliveryAddress,
      selectedDate,
      addressIdsToUpdate,
    } = this.state

    let data = {
      id,
      careOf,
      customerNumber,
      addressLine1,
      postCode,
      area,
      updateDeliveryAddress,
      activationDate: formatDate(selectedDate, 'L'),
      addressIdsToUpdate,
    }

    if (addressIdsToUpdate.length > 0) {
      this.props.onSubmit(data)
    }
  }
}

EditAddresses.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  invoiceAddresses: PropTypes.array.isRequired,
  deliveryAddress: PropTypes.object.isRequired,
}
